import { __t } from '../i18n/t'

/**
 * Validate do ArrayInput de postos. O `required()` do react-admin só olha o tamanho do
 * array: `[null]` (linha fantasma) passa e vira `places: []` no payload, que o backend
 * recusa com "places must contain at least 1 items". Aqui só conta linha com posto.
 */
export const validatePlaces = (value: unknown): string | undefined =>
  Array.isArray(value) && value.some((row) => row && row.placeId)
    ? undefined
    : __t('Adicione pelo menos um posto')

/**
 * Postos do produto no formato do POST. Descarta linha nula (fantasma do ArrayInput) e
 * entrada nula de `productPlaceGiftFuels`; null/'' em vez de lista dava 400 "must be an array".
 * Linha com dado parcial NÃO é descartada: o required() do form é quem barra.
 */
export const buildProductPlaces = (places: any[] | undefined) =>
  (places || [])
    .filter(Boolean)
    .map(({ placeId, price, costValueType, costValue, defaultStock, partnerPrice, limit, minimumStock, minimumAmount, isGift, discountValue, daysToExpire, rtiCode, trevoServiceId, isEvoActive, isSanvitron, isTeixeiraPinto, sislavDiscountPercentage, sislavOnWasher, sislavOnDryer, productPlaceGiftFuels }) => ({
      placeId, price, costValueType, costValue, defaultStock, minimumStock, minimumAmount, isGift, discountValue, daysToExpire, rtiCode, trevoServiceId, isEvoActive, isSanvitron, isTeixeiraPinto, sislavDiscountPercentage, sislavOnWasher, sislavOnDryer,
      partnerPrice: partnerPrice ? +partnerPrice : null,
      limit: limit ? +limit : null,
      productPlaceGiftFuels: Array.isArray(productPlaceGiftFuels) ? productPlaceGiftFuels.filter(Boolean) : [],
    }))
